import { render, staticRenderFns } from "./AssetDepreciationProjection.vue?vue&type=template&id=2bf7ff4a&"
import script from "./AssetDepreciationProjection.vue?vue&type=script&lang=ts&"
export * from "./AssetDepreciationProjection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bf7ff4a')) {
      api.createRecord('2bf7ff4a', component.options)
    } else {
      api.reload('2bf7ff4a', component.options)
    }
    module.hot.accept("./AssetDepreciationProjection.vue?vue&type=template&id=2bf7ff4a&", function () {
      api.rerender('2bf7ff4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/assets/Reports/AssetDepreciationProjection.vue"
export default component.exports